import { FC, SyntheticEvent, useState } from 'react';
import escape from 'lodash/escape';
import { useMutation } from '@apollo/client';

import ELEMENT from 'common/element';

import Page from 'components/common/Page/Page';
import ResizableTextArea from 'components/common/Input/ResizableTextArea';

import EditParser from './Components/EditParser/EditParser';
import ParserOutput from './Components/ParserOutput/ParserOutput';
import { TEST_PARSER } from './queries';
import './styles.scss';

const LogParseTesterPage: FC = () => {
  const [parserValue, setParserValue] = useState<string>('');
  const onParserValueChange = (newValue: string): void => {
    setParserValue(newValue);
  };

  const [testData, setTestData] = useState('');
  const [testParser, { data }] = useMutation(TEST_PARSER);

  // TODO: add error handling
  const onUpdateParserOutput = (): void => {
    testParser({
      variables: { testData, showDetailedOutput: false, textContent: parserValue },
    });
  };

  const onLogSampleChange = (e: SyntheticEvent): void => {
    setTestData((e.target as HTMLTextAreaElement).value);
  };

  const parserOutputContent = data?.testParser?.log || '';

  return (
    <Page docTitle="Log Parsing Tester" type="full" hasBackground>
      <div className="ParserPage">
        <EditParser
          parserValue={parserValue}
          onParserValueChange={onParserValueChange}
          className="ParserPage__EditParser"
          parser=""
          isTester
        />
        <div className="ParserPage__LogSample">
          <ResizableTextArea
            fullHeight
            value={testData}
            onChange={onLogSampleChange}
            placeholder="Paste your logs sample"
            inputClassName="ParserPage__TextArea"
            testId={ELEMENT.logSampleContainer}
          />
        </div>
        <ParserOutput
          className="ParserPage__ParserOutput"
          parserOutputContent={escape(parserOutputContent)}
          onUpdateParserOutput={onUpdateParserOutput}
        />
      </div>
    </Page>
  );
};

export default LogParseTesterPage;
